import React from "react";
import { Link } from "react-router-dom";

function History() {
  return (
    <div>
      <section
        className="page-title"
        style={{
          backgroundImage: "url(../images/background/bg-page-title-1.jpg)",
        }}
      >
        <div className="auto-container">
          <h1>주요연혁</h1>
          <div className="bread-crumb-outer">
            <ul className="bread-crumb clearfix">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li className="active">주요연혁</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="featureStyle1">
        <div className="auto-container">
          <div className="row clearfix">
            <div className="history_area">
              <h3>
                <span>HISTORY</span>
              </h3>
              <ol className="tmh-perspective">
                <li className="hist_r hist_point">
                  <dl>
                    <dt>2020~현재</dt>
                    <dd>
                      전문연구사업자 인증<span>2022</span>
                    </dd>
                    <dd>
                      기술혁신형 중소기업(이노비즈)인증<span>2021</span>
                    </dd>
                    <dd>
                      경영혁신형 중소기업(메인비즈)인증<span>2020</span>
                    </dd>
                  </dl>
                </li>
                <li className="hist_l">
                  <dl>
                    <dt>2016~2017</dt>
                    <dd>
                      <span>2017</span>기술보증기금 벤처기업확인서(재발급)
                    </dd>
                    <dd>
                      <span>2017</span>중소기업청 경영혁신형
                      중소기업(Maino-Biz)
                    </dd>
                    <dd>
                      <span>2016</span>SK텔레콤 IoT 전문기업 인증(로라)
                    </dd>
                  </dl>
                  <p className="bg_list"></p>
                </li>
                <li className="hist_r">
                  <dl>
                    <dt>2015</dt>
                    <dd>
                      <span>2015</span>안산 CCTV 유정보센터 운영 유지 보수
                    </dd>
                    <dd>
                      <span>2015</span>U-City 정보, 전산시스템 운영 유지 보수
                    </dd>
                    <dd>
                      <span>2015</span>LBS 안심 서비스 통합 운영(SKT)
                    </dd>
                    <dd>
                      <span>2015</span>공정관리 RFID 시스템 공급(STS 반도체통신)
                    </dd>
                    <dd>
                      <span>2015</span>공정관리 RFID 시스템
                      공급(제이셋스태츠칩팩)
                    </dd>
                    <dd>
                      <span>2015</span>RF 스마트치매관리시스템 운영 및 고도화
                    </dd>
                    <dd>
                      <span>2015</span>LBS B2B 플렛폼 고도화 개발
                    </dd>
                    <dd>
                      <span>2015</span>생활편익서비스 키핑 계산기 APP 출시
                    </dd>
                  </dl>
                  <p className="bg_list"></p>
                </li>
                <li className="hist_l">
                  <dl>
                    <dt>2013-2014</dt>
                    <dd>
                      <span>2014</span>U-City 운영 유지 보수
                    </dd>
                    <dd>
                      <span>2014</span>포인트캠 서비스 운영 유지 보수
                    </dd>
                    <dd>
                      <span>2014</span>스마트치매관리시스템 개발
                    </dd>
                    <dd>
                      <span>2013</span>U-City 2단계 사업 운영 유지 보수
                    </dd>
                  </dl>
                  <p className="bg_list"></p>
                </li>
                <li className="hist_r">
                  <dl>
                    <dt>2012</dt>
                    <dd>
                      <span>2012</span>서울시 사물지능 통신시스템 유지보수 용역
                    </dd>
                    <dd>
                      <span>2012</span>SKT Geovision 서비스 2차 고도화
                    </dd>
                    <dd>
                      <span>2012</span>KB국민은행 종합부동산 정보시스템 개발
                    </dd>
                    <dd>
                      <span>2012</span>하나마이크론 공정관리용 RFID 시스템
                      미들웨어 S/W개발
                    </dd>
                    <dd>
                      <span>2012</span>SKT 자산관리(Data Info) 시스템 고도화
                    </dd>
                    <dd>
                      <span>2012</span>안산시 U-City 2단계 구축 민자사업(BTL)
                    </dd>
                    <dd>
                      <span>2012</span>안산시 스마트그린 U-City 건설 및 운영모델
                      개발사업
                    </dd>
                  </dl>
                  <p className="bg_list"></p>
                </li>
                <li className="hist_l">
                  <dl>
                    <dt>2011</dt>
                    <dd>
                      <span>2011</span>T-STORE LBS API 개발완료
                    </dd>
                    <dd>
                      <span>2011</span>지식경제부 서비스 연구개발업 인증
                    </dd>
                    <dd>
                      <span>2011</span>상권분석서비스 런칭
                    </dd>
                    <dd>
                      <span>2011</span>스마트 세일즈 런칭
                    </dd>
                    <dd>
                      <span>2011</span>자녀안심플러스 리뉴얼 런칭
                    </dd>
                    <dd>
                      <span>2011</span>RFID시스템 해외 수출
                    </dd>
                    <dd>
                      <span>2011</span>IFEZ U-도시계획 타당성 분석
                    </dd>
                  </dl>
                  <p className="bg_list"></p>
                </li>
                <li className="hist_r">
                  <dl>
                    <dt>2010</dt>
                    <dd>
                      <span>2010</span>Sales City 행안부 우수SW 선정
                    </dd>
                    <dd>
                      <span>2010</span>SKT 자산관리 시스템 개발
                    </dd>
                    <dd>
                      <span>2010</span>위치정보 및 T-MAP 제공 API개발
                    </dd>
                    <dd>
                      <span>2010</span>반도체공정 생산자동화 솔루션 공급
                    </dd>
                    <dd>
                      <span>2010</span>U-도시계획 및 기본설계(김포, 청중)
                    </dd>
                    <dd>
                      <span>2010</span>행안부 스마트비즈니스 센터 구축
                    </dd>
                    <dd>
                      <span>2010</span>국토해양부 U-Eco City 과제 수행
                    </dd>
                    <dd>
                      <span>2010</span>SKT GeoVision 사업참여
                    </dd>
                    <dd>
                      <span>2010</span>차량관제 스마트키 개발(스마트폰)
                    </dd>
                    <dd>
                      <span>2010</span>일자리창출 우수기업 선정(서울시)
                    </dd>
                  </dl>
                  <p className="bg_list"></p>
                </li>
                <li className="hist_l">
                  <dl>
                    <dt>2009</dt>
                    <dd>
                      <span>2009</span>삼성전자 바다플랫폼(Location) 개발
                    </dd>
                    <dd>
                      <span>2009</span>엠코코리아 FMC 구축
                    </dd>
                    <dd>
                      <span>2009</span>SKT u-Parking 개발
                    </dd>
                    <dd>
                      <span>2009</span>SKCC MACS 개발
                    </dd>
                    <dd>
                      <span>2009</span>Sales City (부천시)
                    </dd>
                    <dd>
                      <span>2009</span>엠코 출입관리
                    </dd>
                    <dd>
                      <span>2009</span>해외 LBS 영업 툴
                    </dd>
                  </dl>
                  <p className="bg_list"></p>
                </li>
                <li className="hist_r">
                  <dl>
                    <dt>2008</dt>
                    <dd>
                      <span>2008</span>위치관제 계약(유니모/Forcetec)
                    </dd>
                    <dd>
                      <span>2008</span>2008 우수 파트너상 수상(SKT)
                    </dd>
                    <dd>
                      <span>2008</span>위치기반 골프서비스 개발
                    </dd>
                    <dd>
                      <span>2008</span>USN미들웨어 3차년도 개발(ETRI)
                    </dd>
                    <dd>
                      <span>2008</span>능동형 텔레매트릭스 3차년도
                      개발(KDN/현중)
                    </dd>
                    <dd>
                      <span>2008</span>엠코코리아 패키징 프로세스 RFID시스템
                      납품
                    </dd>
                  </dl>
                  <p className="bg_list"></p>
                </li>
                <li className="hist_l">
                  <dl>
                    <dt>2007</dt>
                    <dd>
                      <span>2007</span>World-wide GIS Map솔루션 / deCarta
                    </dd>
                    <dd>
                      <span>2007</span>SKT 법인대리점 계약
                    </dd>
                    <dd>
                      <span>2007</span>글로벌 로밍서비스 런칭
                    </dd>
                    <dd>
                      <span>2007</span>USN미들웨어 기술이전(ETRI)
                    </dd>
                    <dd>
                      <span>2007</span>USN미들웨어 활용한 산불감시 시스템 개발
                    </dd>
                    <dd>
                      <span>2007</span>RFID 등하교 알림서비스 개시
                    </dd>
                  </dl>
                  <p className="bg_list"></p>
                </li>
                <li className="hist_r">
                  <dl>
                    <dt>2006</dt>
                    <dd>
                      <span>2006</span>위치정보사업자 허가
                    </dd>
                    <dd>
                      <span>2006</span>USN 미들웨어 ETRI 공동 개발 참여 업체
                      선정(3년)
                    </dd>
                    <dd>
                      <span>2006</span>호주 I-KIDS서비스
                    </dd>
                    <dd>
                      <span>2006</span>차량위치 확인 및 관제 서비스 GPSBlock
                      네덜란드 서비스 개시
                    </dd>
                    <dd>
                      <span>2006</span>산산협력 고객생성 위치정보(ULID) 이용 및
                      관리 프로젝트 선정(정보통신진흥원)
                    </dd>
                    <dd>
                      <span>2006</span>
                    </dd>
                  </dl>
                  <p className="bg_list"></p>
                </li>
                <li className="hist_l">
                  <dl>
                    <dt>2005</dt>
                    <dd>
                      <span>2005</span>SKT 제주도 위치기반 PUSH서비스 개발
                    </dd>
                    <dd>
                      <span>2005</span>국내 최초 휴대폰 VM안심드라이브
                      상용서비스(SK Telecom)
                    </dd>
                    <dd>
                      <span>2005</span>해외향(SGM) I-KIDS 개발 계약(SK Telecom)
                    </dd>
                    <dd>
                      <span>2005</span>해외아이키즈 유지보수계약 및 Block서비스
                      개발 계약(유럽 SF Alert)
                    </dd>
                    <dd>
                      <span>2005</span>SKT LBS 우수 제안 공모 수상
                    </dd>
                    <dd>
                      <span>2005</span>SKT 우수 운영유지보수 업체 수상
                      (안심귀가, 아이키즈) 유럽 GSM/GRPS I-KIDS
                    </dd>
                    <dd>
                      <span>2005</span>서비스 오픈(SFA/KPN)
                    </dd>
                    <dd>
                      <span>2005</span>단말 Application을 이용한
                      교통정보수집시스템 개발 계약(SK Telecom)
                    </dd>
                    <dd>
                      <span>2005</span>SK 행복동반자 업체 선정 및 감사패 수여
                    </dd>
                    <dd>
                      <span>2005</span>전력사업 센서네트워크 구축 사업 참여(KDN
                      & 현대중공업)
                    </dd>
                  </dl>
                  <p className="bg_list"></p>
                </li>
                <li className="hist_r">
                  <dl>
                    <dt>2004</dt>
                    <dd>
                      <span>2004</span>SKT GPS Locator Platform 및 Application
                      개발 계약
                    </dd>
                    <dd>
                      <span>2004</span>SKT Pointing Service Platform 및
                      Application 개발 계약
                    </dd>
                    <dd>
                      <span>2004</span>NATE 위치알림이 서비스 오픈(SK Telecom)
                    </dd>
                    <dd>
                      <span>2004</span>SKT 안전운전도우미(안심드라이브) 개발,
                      시범서비스
                    </dd>
                    <dd>
                      <span>2004</span>SKT i-KIDSTM 상용 서비스 오픈 SKT
                      커플위치교환 VM서비스 오픈
                    </dd>
                    <dd>
                      <span>2004</span>SKT Biz Solution 아이디어
                      수상(안심드라이브)
                    </dd>
                  </dl>
                  <p className="bg_list"></p>
                </li>
                <li className="hist_l">
                  <dl>
                    <dt>2003</dt>
                    <dd>
                      <span>2003</span>위치관제 계약(유니모Forcetec)
                    </dd>
                    <dd>
                      <span>2003</span>우수파트너상 수상(SKT)
                    </dd>
                    <dd>
                      <span>2003</span>위치기반골프서비스 개발
                    </dd>
                    <dd>
                      <span>2003</span>USN미들웨어 3차년도 개발()ETRI
                    </dd>
                    <dd>
                      <span>2003</span>능동형 텔레매트릭스 3차년도
                      개발(KDN/현중)
                    </dd>
                    <dd>
                      <span>2003</span>엠코 코리아 패키징 프로세스 RFID시스템
                      납품
                    </dd>
                  </dl>
                  <p className="bg_list"></p>
                </li>
                <li className="hist_r">
                  <dl>
                    <dt>2002</dt>
                    <dd>
                      <span>2002</span>10월 (주)넥스모어시스템즈 법인설립
                    </dd>
                    <dd>
                      <span>2002</span>WTI LBS사업부 인수(측위기술)
                    </dd>
                    <dd>
                      <span>2002</span>SKT 위치 결정 기술 개발 용역
                    </dd>
                  </dl>
                  <p className="bg_list"></p>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default History;
